import { render, staticRenderFns } from "./ProjectGuests.vue?vue&type=template&id=197499b4"
import script from "./ProjectGuests.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectGuests.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProjectGuests.vue?vue&type=style&index=0&id=197499b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports